import { PartialTranslation } from '../translations';

export const ms: PartialTranslation = {
  newChat: 'Sembang Baharu',
  search: 'Cari',
  user: 'Pengguna',
  settings: 'Tetapan',
  language: 'Bahasa',
  getHelp: 'Dapatkan bantuan',
  viewAllPlans: 'Lihat semua pelan',
  learnMore: 'Ketahui lebih lanjut',
  logOut: 'Log keluar',
  chooseLanguage: 'Pilih Bahasa',
  chooseYourPreferredLanguage: 'Pilih bahasa pilihan anda',
  searchLanguages: 'Cari bahasa...',
  autoDetect: 'Kesan Automatik',
  noLanguagesFound: 'Tiada bahasa dijumpai',
  askAnything: 'Tanya apa sahaja',
  lawhelperAi: 'Lawhelper.ai',
  personal: 'Peribadi',
  freePlan: 'Pelan percuma',
  current: 'Semasa',
  close: 'Tutup',
  archive: 'Arkib',
  delete: 'Padam',
  confirmDelete: 'Adakah anda pasti mahu memadam sembang ini?',
  confirmArchive: 'Adakah anda pasti mahu mengarkib sembang ini?',
  deleteCannotUndo: 'Tindakan ini tidak boleh dibuat asal.',
  archiveCanFind: 'Anda boleh menjumpainya dalam senarai arkib selepas pengarkiban.',
  resources: 'Sumber',
  addResource: 'Tambah Sumber',
  deleteResource: 'Padam Sumber',
  noMatchingResourcesFound: 'Tiada sumber yang sepadan dijumpai',
  noResourcesAvailable: 'Tiada sumber tersedia',
  hideResources: 'Sembunyikan Sumber',
  showResources: 'Tunjukkan Sumber',
  typeMessage: 'Taip mesej...',
  thinkingOptions: 'Pilihan pemikiran',
  deleteFile: 'Padam fail',
  clearSelection: 'Kosongkan pilihan',
  addAttachment: 'Tambah lampiran',
  sendMessage: 'Hantar mesej',
  deepInsight: 'Wawasan Mendalam · Analisis Permukaan',
  deepInsightDesc: 'Pemahaman pantas perkara utama',
  deepExploration: 'Penerokaan Mendalam · Analisis Menyeluruh',
  deepExplorationDesc: 'Penyelidikan mendalam pelbagai dimensi',
  deepDeconstruction: 'Dekonstruksi Mendalam · Hujah Sistematik',
  deepDeconstructionDesc: 'Analisis progresif berlapis',
  contractReview: 'Semakan Kontrak · Pengenalpastian Risiko',
  contractReviewDesc: 'Analisis klausa dan pemeriksaan pematuhan',
  textPolish: 'Gilap Teks · Ekspresi Profesional',
  textPolishDesc: 'Pengoptimuman bahasa dan penyesuaian struktur',
  legalDocuments: 'Dokumen Undang-undang · Draf Standard',
  legalDocumentsDesc: 'Penulisan dokumen undang-undang profesional',

  // 认证和隐私翻译 (English fallback - needs translation)
  login: 'Log Masuk',
  register: 'Daftar',
  welcomeBack: 'Selamat Datang ke LawHelper',
  loginSubtitle: 'Pembantu Penyelidikan Undang-undang AI Anda',
  continueWithGoogle: 'Teruskan dengan Google',
  continueWithMicrosoft: 'Teruskan dengan Microsoft',
  continueWithWeChat: 'Teruskan dengan WeChat',
  orContinueWith: 'atau teruskan dengan',
  emailTab: 'E-mel',
  phoneTab: 'Telefon',
  emailPlaceholder: 'Masukkan e-mel anda',
  phonePlaceholder: 'Masukkan nombor telefon',
  codePlaceholder: 'Masukkan kod 6 digit',
  sending: 'Menghantar...',
  verifying: 'Mengesahkan...',
  verify: 'Sahkan',
  sendMagicLink: 'Hantar pautan ajaib',
  getVerificationCode: 'Dapatkan kod',
  resendCode: 'Hantar semula kod',
  resendIn: 'Hantar semula dalam',
  magicLinkSent: 'Pautan ajaib telah dihantar ke e-mel anda',
  magicLinkHint: 'Kami akan menghantar pautan selamat ke e-mel anda',
  otpSent: 'Kod pengesahan telah dihantar',
  agreeToTerms: 'Dengan meneruskan, anda bersetuju dengan',
  privacyPolicy: 'Dasar Privasi',
  termsOfService: 'Syarat Perkhidmatan',
  and: 'dan',
  privacyTitle: 'Privasi anda penting',
  privacyIntro: 'Kami menggunakan kuki dan teknologi serupa untuk memberikan pengalaman terbaik.',
  essentialCookies: 'Kuki penting',
  essentialDesc: 'Diperlukan supaya laman web berfungsi',
  analyticsCookies: 'Kuki analitik',
  analyticsDesc: 'Membantu kami meningkatkan perkhidmatan',
  marketingCookies: 'Kuki pemasaran',
  marketingDesc: 'Digunakan untuk kandungan peribadi',
  acceptAll: 'Terima semua',
  essentialOnly: 'Hanya penting',
  customize: 'Sesuaikan',
  savePreferences: 'Simpan pilihan',
  back: 'Kembali',
  readPrivacyPolicy: 'Baca dasar privasi kami',
  cookiePolicy: 'Dasar kuki',
  gdprCompliance: 'GDPR',
  piplCompliance: 'PIPL',

  // AI工具面板
  aiReview: 'Semakan AI',
  aiDraft: 'Draf AI',
  smartAssistant: 'Templat',

  // 知识库搜索
  enableKnowledgeSearch: 'Aktifkan carian',
  knowledgeSearchDesc: 'AI mencari dokumen anda',
  clickToDisable: 'Nyahaktif',
  clickToEnable: 'Aktifkan',

  // Landing page translations
  tagline: 'AI-Powered Legal Intelligence',
  heroTitle1: 'Legal AI',
  heroTitle2: 'Simplified.',
  jurisdictionsLabel: 'Jurisdictions',
  accuracyLabel: 'Accuracy',
  fasterLabel: 'Faster',
  availableLabel: 'Available',
  platformCapabilities: 'Platform Capabilities',
  testimonialQuote: '"LawHelper has transformed how we handle legal work. Contract review is 10x faster, with incredible accuracy."',
  testimonialAuthor: 'Legal Professional',
  testimonialPosition: 'Partner at Top Law Firm',
  viewPricing: 'View Pricing',
  footerPricing: 'Pricing',
  footerPrivacy: 'Privacy',
  footerTerms: 'Terms',
  footerContact: 'Contact',
  footerCopyright: '© 2024 LawHelper. All rights reserved.',

  // Onboarding Guide
  onboardingWelcome: 'Welcome to Lawhelper.ai',
  onboardingSkip: 'Skip',
  onboardingNext: 'Next',
  onboardingPrev: 'Back',
  onboardingGetStarted: 'Get Started',
  onboardingSlide1Title: 'AI Legal Chat',
  onboardingSlide1Desc: 'Ask any legal question and get precise, jurisdiction-aware answers powered by advanced AI.',
  onboardingSlide2Title: 'Case Folder System',
  onboardingSlide2Desc: 'Organize your documents by case. Upload files and control which materials AI uses as context.',
  onboardingSlide3Title: 'Local Folder Access',
  onboardingSlide3Desc: 'Connect local directories in the browser. Preview, edit, and send files to AI chat.',
  onboardingSlide4Title: 'AI Drafting & Review',
  onboardingSlide4Desc: 'Draft legal documents with AI and review contracts to identify risks automatically.',
  onboardingGuide: 'Guide',
  mentionFiles: "Reference a file",

  // Auto-synced keys
  chats: 'Chats',
  archived: 'Archived',
  restore: 'Restore',
  noArchivedChats: 'No archived chats',
  backToChats: 'Back to Chats',
  closeResourcesPanel: 'Tutup panel sumber',
  uploading: 'Memuat naik %{fileName}...',
  processing: 'Memproses %{fileName}...',
  uploadSuccess: '✓ %{fileName} dimuat naik',
  uploadError: '✗ Muat naik gagal: %{error}',
  quickAnswer: 'Jawapan Pantas',
  quickAnswerDesc: 'Jawapan pantas untuk soalan mudah',
  cancelRequest: 'Batal',
  library: 'Perpustakaan',
  filterAll: 'Semua',
  filterChat: 'Sembang',
  filterReview: 'Semakan',
  filterDraft: 'Draf',
  filterTemplate: 'Templat',
  filterForm: 'Borang',
  thinking: 'Berfikir...',
  thinkingProcess: 'Proses berfikir',
  analyzingLegalLogic: 'Menganalisis logik undang-undang...',
  lawhelperThinking: 'Lawhelper sedang berfikir...',
  serviceError: 'Ralat perkhidmatan',
  uploaded: 'Dimuat naik',
  settingsGeneral: 'Umum',
  settingsNotifications: 'Pemberitahuan',
  settingsAppearance: 'Penampilan',
  settingsProfile: 'Profil',
  settingsResponseNotifications: 'Pemberitahuan respons',
  settingsResponseNotificationsDesc: 'Pemberitahuan apabila respons AI selesai',
  settingsColorMode: 'Mod warna',
  settingsLight: 'Cerah',
  settingsDark: 'Gelap',
  settingsSystem: 'Sistem',
  about: 'Tentang',
  reviewTitle: 'Semakan dokumen',
  exitReview: 'Keluar semakan',
  uploadPrompt: 'Muat naik PDF untuk semakan',
  uploadButton: 'Pilih fail',
  startChatConfig: 'Taip "Semak dokumen ini"',
  reviewPlaceholder: 'Taip mesej...',
  analyzing: 'Menyemak...',
  reviewComplete: 'Semakan selesai',
  issuesFound: 'Dijumpai %{count} masalah',
  draftTitle: 'Penyediaan dokumen undang-undang',
  draftPlaceholder: 'Edit di sini atau minta AI...',
  analyzingTemplate: 'Menganalisis templat %{name}...',
  templateAnalyzed: '✅ Templat %{name} dianalisis!',
  templateAnalysisPrompt: 'Analisis klausa utama',
  parsingFailed: '⚠️ Gagal menganalisis fail.',
  generating: 'Menjana...',
  generatedSuccess: '✅ Dokumen dijana!',
  drafterWelcome: 'Selamat datang ke Pembantu Dokumen AI',
  drafterYouCan: 'Anda boleh:',
  drafterUploadTemplate: 'Muat naik templat untuk analisis AI',
  drafterDescribeNeeds: 'Huraikan keperluan dokumen',
  drafterLetAiHelp: 'AI membantu merangka kontrak, perjanjian, dll.',
  drafterExamples: 'Contoh:',
  drafterExampleRental: '"Draf kontrak sewa"',
  drafterExampleLabor: '"Isi kontrak kerja"',
  drafterInputPlaceholder: 'Huraikan keperluan anda...',
  drafterThinking: 'Berfikir...',
  drafterHistoryTitle: 'Sejarah',
  drafterNoHistory: 'Tiada sejarah',
  drafterNewChat: 'Sembang baru',
  drafterHistory: 'Sejarah',
  drafterRemoveAttachment: 'Buang lampiran',
  drafterLineHeight: 'Ketinggian baris',
  drafterLineHeightSuffix: 'x',
  drafterExportWord: 'Eksport Word (.docx)',
  drafterExportPdf: 'Eksport PDF',
  drafterSave: 'Simpan dokumen',
  drafterDownload: 'Muat turun dokumen',
  drafterUndo: 'Buat asal',
  drafterRedo: 'Buat semula',
  drafterBold: 'Tebal',
  drafterItalic: 'Italik',
  drafterStrike: 'Potong',
  drafterUnderline: 'Garis bawah',
  drafterHighlight: 'Serlah',
  drafterLink: 'Sisip pautan',
  drafterAlignLeft: 'Kiri',
  drafterAlignCenter: 'Tengah',
  drafterAlignRight: 'Kanan',
  drafterAlignJustify: 'Justify',
  drafterList: 'Senarai',
  drafterBulletList: 'Senarai bullet',
  drafterOrderedList: 'Senarai bernombor',
  drafterTaskList: 'Senarai tugas',
  drafterOpenResource: 'Buka panel sumber',
  drafterStopGeneration: 'Hentikan penjanaan',
  drafterAgentMode: 'Mod Ejen aktif',
  drafterAgentModeOn: 'Mod Ejen aktif',
  drafterAgentModeOff: 'Mod biasa',
  drafterUploadAttachment: 'Muat naik lampiran',
  drafterExit: 'Keluar',
  drafterConfirm: 'Sahkan',
  drafterOpenLink: 'Buka pautan',
  drafterDeleteLink: 'Padam pautan',
  drafterQuote: 'Petikan',
  workflowTitle: 'Aliran kerja AI',
  workflowRunning: 'Berjalan...',
  workflowReady: 'Sedia',
  workflowCompleted: 'Selesai',
  workflowStartFailed: 'Gagal memulakan aliran kerja',
  workflowExecutionFailed: 'Pelaksanaan gagal',
  workflowInterrupted: 'Aliran kerja terganggu',
  workflowProcessing: 'Memproses...',
  workflowStepsCompleted: 'langkah selesai',
  workflowStepsTotal: 'Aliran kerja selesai (%{count} langkah)',
  acceptChanges: 'Terima perubahan',
  rejectChanges: 'Tolak perubahan',
  changesAccepted: 'Perubahan diterima',
  changesRejected: 'Perubahan ditolak',
  stopWorkflow: 'Hentikan',
  restartWorkflow: 'Mulakan semula',
  startDrafting: 'Mula merangka',
  interrupt: 'Hentikan',
  documentSubject: 'Subjek dokumen *',
  documentType: 'Jenis dokumen',
  jurisdiction: 'Bidang kuasa',
  specialRequirements: 'Keperluan khas (pilihan)',
  clickStartDrafting: 'Klik "Mula merangka"',
  docTypeContract: 'Kontrak',
  docTypeAgreement: 'Perjanjian',
  docTypeNotice: 'Notis',
  docTypeLetter: 'Surat',
  docTypePetition: 'Petisyen',
  docTypeWill: 'Wasiat',
  docTypePowerOfAttorney: 'Surat kuasa',
  countryChina: 'China',
  countryUSA: 'Amerika Syarikat',
  countryGermany: 'Jerman',
  countryJapan: 'Jepun',
  countryFrance: 'Perancis',
  countryUK: 'United Kingdom',
  citationVerified: 'Disahkan',
  citationUnverified: 'Belum disahkan',
  imageLoadFailed: 'Gagal memuatkan imej',
  smartDocTitle: 'Pembantu dokumen pintar',
  smartDocChatTitle: 'Pembantu dokumen AI',
  smartDocDropPrompt: 'Lepas fail PDF di sini',
  smartDocSelectFile: 'Pilih fail',
  smartDocOr: 'atau',
  smartDocWelcomeTitle: 'Selamat datang ke Pembantu AI',
  smartDocWelcomeYouCan: 'Anda boleh:',
  smartDocUploadForAI: 'Muat naik templat',
  smartDocDescribeDoc: 'Huraikan keperluan',
  smartDocLetAIDraft: 'AI membantu kontrak',
  smartDocExamples: 'Contoh:',
  smartDocExampleRental: '"Draf kontrak sewa"',
  smartDocExampleLabor: '"Isi kontrak kerja"',
  smartDocInputPlaceholder: 'Huraikan keperluan...',
  smartDocRemoveAttachment: 'Buang lampiran',
  smartDocOpenResources: 'Buka sumber',
  smartDocExit: 'Keluar',
  reviewStartFailed: 'Gagal memulakan semakan',
  reviewFailed: 'Semakan gagal',
  reviewFoundIssues: 'Semakan selesai, %{count} masalah.',
  cannotReadStream: 'Tidak dapat membaca strim',
  parseEventFailed: 'Gagal menganalisis peristiwa',
  errorPrefix: 'Ralat',
  unknownError: 'Ralat tidak diketahui',
  file: 'Fail',
  loading: 'Memuatkan...',
  localFolders: 'Folder tempatan',
  selectLocalFolder: 'Pilih folder tempatan',
  reselectFolder: 'Tukar folder',
  addToContext: 'Tambah ke sembang',
  saveFile: 'Simpan',
  renameFile: 'Namakan semula',
  fileSaved: 'Fail disimpan',
  fileRenamed: 'Fail dinamakan semula kepada %{name}',
  browserNotSupported: 'Pelayar tidak menyokong akses folder',
  noFolderSelected: 'Pilih folder tempatan',
  scanningFolder: 'Mengimbas folder...',
  selectFileToPreview: 'Pilih fail untuk pratonton',
  aiAnalyze: 'Analisis AI',
};
